import { useMutation } from '@tanstack/react-query';

import { toast } from 'react-toastify';
import { updateUser } from '../../API/functions';
import useCheckUser from './useCheckUser';

export const useUpdateUser = () => {
  const { mutate: checkUser } = useCheckUser(); 

  const { mutate } = useMutation({
    mutationFn: (vars) => updateUser(vars),
    onSuccess: (data) => {
      checkUser(data.data.wallet_address );

      toast.success(data.message);
    },
    onError: (error) => {
      toast.error(error.response.data.message);
    },
  });

  return { mutate };
};
